'use client';

import useStore from '@/stores/store';

const useHasUserSession = () => {
  const userId = useStore((state) => state.user?.profile?.id);
  return userId > 0;
};

export default useHasUserSession;
